import { getStatusColor } from '@btime/constants'
import { map } from 'ramda'
import { useChangeFilterValue, useFilterValue } from '@btime/react-contexts'
import React from 'react'

import CheckboxesFilterSideModal from '../../../components/filter/CheckboxesFilterSideModal'
import CheckboxesList from '../../../components/form/CheckboxesList'
import FlexGrid from '../../../components/structure/FlexGrid'
import StatusTag from '../../serviceOrders/StatusTag'
import StatusesLoader, { useTranslatedStatuses } from '../_load/StatusesLoader'

const renderValue = (values, options) => {
  if (!values || !values.length) return false
  const formattedSelectedValues = map(item => <StatusTag key={item.value} item={item.origin} />, values) || []

  return (
    <FlexGrid justify="flex-start" wrap gutter={0.1}>
      {formattedSelectedValues}
    </FlexGrid>
  )
}

const renderOptions = (options, values, setValue) => {
  return (
    <CheckboxesList
      value={values}
      onChange={setValue}
      options={options}
      renderRightBorderColor={(value, label, obj) => getStatusColor(obj.name)}
      cleanLabel
    />
  )
}

const StatusesFilterSideModal = ({ field, label, onClose, ...props }) => {
  field = field || 'statusIds'
  label = label || 'Status'
  const value = useFilterValue(field, [])
  const handleChange = useChangeFilterValue()

  return (
    <CheckboxesFilterSideModal
      labelKey="label"
      renderOptions={renderOptions}
      renderValue={renderValue}
      label={label}
      value={value}
      dataHook={useTranslatedStatuses}
      onSubmit={handleChange(field)}
      Loader={StatusesLoader}
      onClose={v => {
        handleChange(field, v)
        onClose()
      }}
      {...props}
    />
  )
}

export default StatusesFilterSideModal
